module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.atualizacao) ? _c('b', [_vm._v("Atualizar Comunicado")]) : _c('b', [_vm._v("Novo Comunicado")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6",
    class: {
      'has-error': _vm.showTextDangerTitulo
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerTitulo
    }
  }, [_vm._v("Título")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.titulo),
      expression: "dados.titulo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "titulo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerDataInicial
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerDataInicial
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_inicial),
      expression: "dados.data_inicial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_inicial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerDataFinal
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerDataFinal
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_final),
      expression: "dados.data_final"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_final", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.showTextDangerSituacao
    }
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerSituacao
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.situacao),
      expression: "dados.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ATIVO"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "INATIVO"
    }
  }, [_vm._v("Inativo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.showTextDangerDescricao
    }
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerDescricao
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('vue-editor', {
    model: {
      value: (_vm.dados.descricao),
      callback: function($$v) {
        _vm.$set(_vm.dados, "descricao", $$v)
      },
      expression: "dados.descricao"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Visível para")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.marcador_visualiza),
      expression: "dados.marcador_visualiza"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.marcador_visualiza) ? _vm._i(_vm.dados.marcador_visualiza, null) > -1 : (_vm.dados.marcador_visualiza)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.dados.marcador_visualiza,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "marcador_visualiza", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "marcador_visualiza", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "marcador_visualiza", $$c)
        }
      }
    }
  }), _vm._v(" Marcadores\n\t\t\t\t\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.prestador_visualiza),
      expression: "dados.prestador_visualiza"
    }],
    staticStyle: {
      "margin-left": "3.5em"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.prestador_visualiza) ? _vm._i(_vm.dados.prestador_visualiza, null) > -1 : (_vm.dados.prestador_visualiza)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.dados.prestador_visualiza,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "prestador_visualiza", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "prestador_visualiza", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "prestador_visualiza", $$c)
        }
      }
    }
  }), _vm._v(" Prestadores\n\t\t\t\t\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.regulador_visualiza),
      expression: "dados.regulador_visualiza"
    }],
    staticStyle: {
      "margin-left": "3.5em"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.regulador_visualiza) ? _vm._i(_vm.dados.regulador_visualiza, null) > -1 : (_vm.dados.regulador_visualiza)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.dados.regulador_visualiza,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "regulador_visualiza", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "regulador_visualiza", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "regulador_visualiza", $$c)
        }
      }
    }
  }), _vm._v(" Reguladores\n\t\t\t\t\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.administrador_visualiza),
      expression: "dados.administrador_visualiza"
    }],
    staticStyle: {
      "margin-left": "3.5em"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.administrador_visualiza) ? _vm._i(_vm.dados.administrador_visualiza, null) > -1 : (_vm.dados.administrador_visualiza)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.dados.administrador_visualiza,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "administrador_visualiza", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "administrador_visualiza", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "administrador_visualiza", $$c)
        }
      }
    }
  }), _vm._v(" Administradores\n\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-54431eec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administracao/comunicados/form.vue
// module id = 849
// module chunks = 0